__turbopack_context__.v({
  "Icon": "app-select-module__Psuexq__Icon",
  "Item": "app-select-module__Psuexq__Item",
  "Trigger": "app-select-module__Psuexq__Trigger",
});
